module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_floral_merlot-ed2a9e77.png";